<template>
  <CHeader with-subheader>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CHeaderBrand
      class="mx-auto d-lg-none"
    >
      <CImg
        width="140"
        height="35"
        :src="imageSwitch"
        alt="Ringba X"
      />
    </CHeaderBrand>
    <CHeaderNav class="d-md-down-none mr-auto">
      <CHeaderNavItem class="px-3">
        <SystemStatus />
      </CHeaderNavItem>
    </CHeaderNav>

    <CHeaderNav>
      <CHeaderNavItem class="px-3">
        <CDropdown 
          v-if="isAccountManager"
          variant="btn-group" 
          color="info"
          toggler-text="My Accounts"
          direction="dropend"
          size="sm"
          dark
        >
          <template #toggler-content>
            <CIcon 
              name="cil-people" 
              class="mr-2 mt-1" 
            />My Accounts
          </template>
          <CDropdownItem
            class="d-flex align-items-center"
            @click="$router.push(`/dashboard/accounts/buyer?accountManager=${currentAccountManagerId}`)"
          >
            Buyers
          </CDropdownItem>
          <CDropdownItem
            class="d-flex align-items-center"
            @click="$router.push(`/dashboard/accounts/seller?accountManager=${currentAccountManagerId}`)"
          >
            Sellers
          </CDropdownItem>
        </CDropdown>
      </CHeaderNavItem>
    </CHeaderNav>

    <CHeaderNav>
      <CHeaderNavItem class="px-3">
        <CDropdown 
          v-if="isAccountManager"
          variant="btn-group" 
          color="info"
          toggler-text="Copy Signup Link"
          direction="dropend"
          size="sm"
          dark
        >
          <template #toggler-content>
            <CIcon 
              name="cil-copy" 
              class="mr-2 mt-1" 
            />Copy Signup Link
          </template>
          <CDropdownItem
            class="d-flex align-items-center"
            @click="copySignupLinkToClipboard(currentAccountManagerId, 'buyer-registration-apply')"
          >
            Buyer
          </CDropdownItem>
          <CDropdownItem
            class="d-flex align-items-center"
            @click="copySignupLinkToClipboard(currentAccountManagerId, 'seller-registration-apply')"
          >
            Seller
          </CDropdownItem>
        </CDropdown>
      </CHeaderNavItem>
    </CHeaderNav>

    <CHeaderNav>
      <CHeaderNavItem class="px-3">
        <button
          class="c-header-nav-btn"
          @click="toggleDarkMode"
        >
          <CIcon
            v-if="darkMode"
            name="cil-sun"
          />
          <CIcon
            v-else
            name="cil-moon"
          />
        </button>
      </CHeaderNavItem>

      <TheHeaderDropdownAccnt class="mr-4" />

      <CHeaderNavItem
        v-if="false"
        class="px-3"
      >
        <button
          class="c-header-nav-btn"
          @click="$store.commit('toggle', 'asideShow')"
        >
          <CIcon
            size="lg"
            name="cil-applications-settings"
            class="mr-2"
          />
        </button>
      </CHeaderNavItem>
    </CHeaderNav>
  </CHeader>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
import copyToClipboardMixin from '@/mixins/copy-to-clipboard-mixin'
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt.vue'
import SystemStatus from '@/components/SystemStatus.vue'
import { showSuccessMessage } from '@/notification-utils'

export default {
  name: 'TheHeader',

  components: {
    TheHeaderDropdownAccnt,
    SystemStatus
  },

  mixins: [copyToClipboardMixin],

  computed: {
    ...mapState(['darkMode']),

    ...mapState('auth', ['userDetails']),

    ...mapGetters('auth', [
      'currentAccountManagerId',
      'isAccountManager'
    ]),

    imageSwitch() {
      return this.darkMode ? '/img/ringbax-logo-dark-theme.svg' : '/img/ringbax-logo-light-theme.svg'
    }
  },

  watch: {
    userDetails: function(newValue) {
      if (newValue?.adminSitePreferences?.preferredTheme) {
        const darkMode = newValue.adminSitePreferences.preferredTheme === 'Dark'
        this.set(['darkMode', darkMode])
      }
    }
  },

  methods: {
    ...mapMutations(['set']),

    ...mapActions('user', ['setUIPreferences']),

    ...mapActions('auth', ['getLoggedInUserDetails']),

    copySignupLinkToClipboard(id, route) {
      const link = `${this.CLIENT_SIDE_BASE_URL}/${route}?accountManagerId=${id}`

      this.copyTextToClipboard(link)
      showSuccessMessage('Signup link copied to clipboard')
    },

    async toggleDarkMode() {
      const preferences = {
        preferredTheme: this.darkMode ? 'Light' : 'Dark'
      }
      
      await this.setUIPreferences(preferences)

      await this.getLoggedInUserDetails()
    },
  }
}
</script>
